<template>
  <div class="tip-widget-page">
    <TipWidget
      title="'How to use BetaScore'"
      :first-description-title="'Boost your loan operations'"
      :first-description-body="'Supplement your loan origination process with BetaScore’s credit report, which uses new and unique data sources not typically accessed by traditional credit bureaus.'"
      :second-description-title="'Reach new customers'"
      :second-description-body="'Search through an entire database of verified businesses throughout the US.'"
    />
  </div>
</template>
    
    <script>
    import TipWidget from '@/components/widget/tip/index.vue';
    
    export default {
      name: "TipWidgetPage",
      components: {
        TipWidget
      }
    };
    </script>
    
    <style scoped lang="scss">
    .tip-widget-page {
    @include inline-space($space-none);
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background-color: #F7F7F4;
    }
    </style>
    